:host {
  --datepicker-dropdown-width: 260px;
}

.wrapper {
  justify-content: space-between;
  padding: calc(var(--spacer) / 2) calc(var(--spacer) * 2.5) 0;
  align-items: center;

  .filters-container {
    flex: 1;
    display: flex;
    flex-wrap: wrap;

    .filter {
      margin-right: calc(2 * var(--spacer));
      margin-bottom: calc(var(--spacer) * 1.25);
      margin-top: calc(var(--spacer));
    }
  }
  backend-enum-filter {
    width: auto;
  }

  gz-datetime-filter {
    --datepicker-width: var(--datepicker-dropdown-width);
  }
  .reset-filters-wrapper {
    height: calc(4 * var(--spacer));
    margin-bottom: calc(var(--spacer) * 1.25);
    margin-top: calc(var(--spacer));
    padding-left: var(--spacer);
    border-left: 1px solid var(--chart-101-pressed-dividers);
    display: flex;
    align-items: center;
    gz-button {
      line-height: 1;
      margin-bottom: calc(var(--spacer) / 2);
    }

    &.d-none {
      display: none;
    }
  }
}

backend-enum-filter {
  &.filter {
    --display: 'inline';
  }
}
